<template>
  <v-dialog
    v-model="dialog"
    :persistent="persistent"
    :max-width="options.width"
    :style="{ zIndex: options.zIndex }"
    @keydown.esc="cancel"
  >
    <v-card>
      <v-toolbar dark :color="options.color" dense flat>
        <v-toolbar-title class="white--text">{{ title }}</v-toolbar-title>
      </v-toolbar>
      <v-card-text v-show="!!message" class="pa-4 body-1" v-html="message" />
      <v-card-actions class="pt-0">
        <v-spacer></v-spacer>
        <v-btn
          v-if="!hasCustomCancel"
          color="primary"
          outlined
          rounded
          @click.native="cancel"
        >
          Cancel
        </v-btn>
        <slot name="cancel"></slot>
        <v-btn color="secondary" rounded @click.native="agree">
          Confirm
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'ConfirmDialog',

  props: {
    persistent: {
      type: Boolean,
      default: false,
    },
  },

  data: () => ({
    dialog: false,
    resolve: null,
    reject: null,
    message: null,
    title: null,
    options: {
      color: 'primary',
      width: 290,
      zIndex: 200,
    },
  }),

  computed: {
    hasCustomCancel() {
      return !!this.$slots.cancel
    },
  },

  methods: {
    open(title, message, options) {
      this.dialog = true
      this.title = title
      this.message = message
      this.options = Object.assign(this.options, options)
      return new Promise((resolve, reject) => {
        this.resolve = resolve
        this.reject = reject
      })
    },
    agree() {
      if (typeof this.resolve === 'function') {
        this.resolve(true)
      }

      this.$emit('confirmed', true)

      this.dialog = false
    },
    cancel() {
      if (typeof this.resolve === 'function') {
        this.resolve(false)
      }

      this.$emit('confirmed', false)

      this.dialog = false
    },
  },
}
</script>
